import React from "react";
import "./LayeredImage.scss";

export default function LayeredImage({
	children,
	className = "",
	width,
	height,
}) {
	let aspectRatio = height / width;
	let padding = aspectRatio * 100;

	return (
		<div className={`layered-image-wrapper ${className}`}>
			<div
				className="layered-image"
				style={{
					paddingTop: `${padding}%`,
				}}
			>
				<div className="layered-image-content">{children}</div>
			</div>
		</div>
	);
}
